export default __webpack_public_path__ + "static/media/hht2_ep18_speaking_01.ccbef5bb.png";